// 统一请求路径前缀在commmon/axios.js中修改
import { getRequest, postRequest,postRequestLogin,putRequest,putNoToken,getRequestWithNoToken } from '../assets/js/api';

// 新增积分
export const _addIntegral = (params) => {
  return postRequest('/api-customer-c/integral/addIntegral', params)
}

// 积分列表
export const _getUserIntegral = (params) => {
  return postRequest('/api-customer-c/integral/getUserIntegral', params)
}
